import { FormFieldState } from '@/common/form/FormFieldState';
import { FormStateBase } from '@/common/form';

export class UsersFormStateTenantUserInvite extends FormStateBase {
  firstName: FormFieldState = new FormFieldState();
  lastName: FormFieldState = new FormFieldState();
  email: FormFieldState = new FormFieldState();
  role: FormFieldState = new FormFieldState();

  constructor() {
    super();
    this.setForm(this);
  }
}
